import { frontendURL } from '../../../helper/URLHelper';
import { FEATURE_FLAGS } from '../../../featureFlags';

const meta = {
  featureFlag: FEATURE_FLAGS.CRM,
  permissions: ['administrator', 'agent'],
};

export const routes = [
  {
    path: frontendURL('accounts/:accountId/groups'),
    component: () => import('./pages/GroupsPage.vue'),
    meta,
    children: [
      {
        path: '',
        name: 'groups_index',
        component: () => import('./pages/GroupsPage.vue'),
        meta,
      },
    ],
  },
];
